























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import RessifnetQuillEditor from "@/components/inputs/RessifnetQuillEditor.vue";
import {BFormFile, BProgress, BButton} from "bootstrap-vue";
import RessifnetDateInput from "@/components/inputs/RessifnetDateInput.vue";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import { DemandeRqth } from "@/api/models/options/demandesRqth/demandeRqth";
import { DemandeLogement } from "@/api/models/dossiers/demandesLogement/demandeLogement";
import { OrganismeDemandeLogement } from "@/api/models/options/organismesDemandeLogement/organismeDemandeLogement";
import { PaginatedList } from "@/api/models/common/paginatedList";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";


@Component({
  components: {
    RessifnetQuillEditor,
    BFormFile,
    BButton,
    BProgress,
    RessifnetDateInput,
    SearchableVueSelect
  },
})
export default class DetailsDemandeLogement extends Vue {
  @Prop({ required: true }) demandeId!: string | null

  demandeEdited: DemandeLogement = {};
  fichiersUploaded = [];
  percentUpload: number = 0;
  listOrganismesDemandeLogement: OrganismeDemandeLogement[] = []
  
  onUploadProgress(percent: any) {
    this.percentUpload = percent;
  }

  @Watch('demandeId')
  async demandeIdChanged() {
    if (this.demandeId) {
      await this.$http.ressifnet.demandesLogement
        .getById(this.$route.params.id, this.demandeId)
        .then((demandeLogement : any) => {
          this.demandeEdited = { 
            ...demandeLogement,
            commentaire: demandeLogement.note?.message,
            fichiers: [] 
          };
          this.fichiersUploaded = demandeLogement.fichiers;
        })
    }
    else {
      this.demandeEdited = {}
      this.fichiersUploaded = []
    }
  }
  
  async created() {
    await this.loadListOrganismesDemandeLogement()
    if (this.demandeId) {
      await this.$http.ressifnet.demandesLogement
        .getById(this.$route.params.id, this.demandeId)
        .then((demandeLogement : any) => {
          this.demandeEdited = { 
            ...demandeLogement,
            commentaire: demandeLogement.note?.message,
            fichiers: [] 
          };
          this.fichiersUploaded = demandeLogement.fichiers;
        })
    }
  }

  
  get fichiers() {
    var files = [];

    if (this.demandeEdited.fichiers && this.demandeEdited.fichiers.length > 0) {
      files = this.demandeEdited
        .fichiers.filter((f: any) => f.id == undefined)
        .map(
          (x: File) =>
            <any>{
              nom: x.name,
            }
        );
    }
    
    return files.concat(this.fichiersUploaded);
  }

  async downloadFile(fichier:any) {
    if (!fichier.id)
      return;
    else {
      await this.$http.ressifnet.fichiersDossiers
        .downloadFile(fichier.id)
        .then(
          async (response: any) => {
            window.open(response);
          },
          (error: any) => {
            if (error?.response?.data?.errors) {
              errorAlert.fire({
                text: error.response.data.errors[
                  Object.keys(error.response.data.errors)[0]
                ],
              });
            } else {
              errorAlert.fire({
                text: error.message,
              });
            }
          }
        );
    }
  }
  async loadListOrganismesDemandeLogement() {
    await this.$http.ressifnet.organismesDemandeLogement
      .paginatedList(1, 100, true)
      .then((res: PaginatedList<OrganismeDemandeLogement>) => {
        this.listOrganismesDemandeLogement = res.items;
      }) 
  }

  async save(callback: any) {
    let config = {
      onUploadProgress(progressEvent: any) {
        var percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );

        callback(percentCompleted);
        return percentCompleted;
      },
    };

    if (this.demandeEdited.id) {
      await this.$http.ressifnet.demandesLogement
        .put(this.$route.params.id, this.demandeEdited.id, this.demandeEdited, config)
        .then(
          (response: any) => {
            this.$emit('reloadDossier');
            this.$emit('reloadNotes');
            this.$emit('reloadFiles');
            successAlert.fire({
              title: "Modification d'une demande logement",
              text: "Modification effectué avec succès",
            });
            this.percentUpload = 0;
          },
          (error: any) => {
            if (
              error?.response?.data?.errors &&
              Object.keys(error.response.data.errors).length
            ) {
              errorAlert.fire({
                text: error.response.data.errors[
                  Object.keys(error.response.data.errors)[0]
                ],
              });
            } else {
              errorAlert.fire({
                text: error?.response?.data?.detail ?? error.message,
              });
            }
            this.percentUpload = 0;
          }
        );
        this.closeDetails()
    }
    else {
      
      let config = {
        onUploadProgress(progressEvent: any) {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );

          callback(percentCompleted);
          return percentCompleted;
        },
      };
      await this.$http.ressifnet.demandesLogement.post(this.$route.params.id, this.demandeEdited, config)
        .then(
          (response: any) => {
            this.$emit('reloadDossier');
            this.$emit('reloadNotes');
            this.$emit('reloadFiles');
            this.percentUpload = 0;
            successAlert.fire({
              title: "Ajout d'une demande logement",
              text: "Ajout effectué avec succès",
            });
            
            this.percentUpload = 0;
          },
          (error: any) => {
            if (
              error?.response?.data?.errors &&
              Object.keys(error.response.data.errors).length
            ) {
              errorAlert.fire({
                text: error.response.data.errors[
                  Object.keys(error.response.data.errors)[0]
                ],
              });
            } else {
              errorAlert.fire({
                text: error?.response?.data?.detail ?? error.message,
              });
            }
          }
        );
        this.closeDetails()
    }
    
    this.$emit('reload-list')
  }

  closeDetails() {
    this.demandeEdited = {
      fichiers : []
    }
    this.$emit('close-details')
  }

  removeFichier(fichier: any) {
    if (fichier.id != undefined) {
      this.$bvModal
        .msgBoxConfirm(
          "Etes-vous sûr de vouloir supprimer ce fichier de la demande logement ? Cela le supprimera directement",
          {
            title: "Confirmation de suppression",
            size: "sm",
            okVariant: "primary",
            okTitle: "Oui",
            cancelTitle: "Non",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then(async (value) => {
          if (value === true) {
            this.confirmRemoveFichier(fichier);
          } else {
            return;
          }
        });
    } else {
      this.demandeEdited.fichiers!.splice(
        (this.demandeEdited.fichiers! as any[]).indexOf(fichier),
        1
      );
    }
  }

  async confirmRemoveFichier(fichier: any) {
    await this.$http.ressifnet.demandesLogement
      .deleteFile(
        this.$route.params.id,
        (this.demandeEdited as any).id,
        fichier.id
      )
      .then((res: any) => {
        this.$emit('reloadDossier');
        this.$emit('reload-list')
        successAlert.fire({
          title: "Suppression d'un document",
          text: "Suppression effectuée avec succès",
        });

        (this.demandeEdited.fichiers! as any[]).push({ id: fichier.id });
        this.fichiersUploaded.splice(
          (this.fichiersUploaded as any[]).indexOf(fichier),
          1
        );
      });
  }

}
